import { createContext } from 'react';

export type WebhookUpdateError = {
  label: string;
  message: string;
};

export type UpdateWebhookCtx = {
  showUpdateSuccessAlert: boolean;
  showUpdateErrorAlert: boolean;
  updateErrors: WebhookUpdateError[];
};

const UpdateWebhook = createContext<UpdateWebhookCtx>({
  showUpdateSuccessAlert: false,
  showUpdateErrorAlert: false,
  updateErrors: [],
});

export default UpdateWebhook;
